var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.visible, "max-width": "30rem", persistent: "" },
      on: { input: _vm.close },
    },
    [
      _c(
        "v-card",
        { attrs: { loading: _vm.loading, disabled: _vm.loading } },
        [
          _c("v-card-title", [
            _vm._v(_vm._s(_vm.$t("pages.settings.users.deleteDialog.title"))),
          ]),
          _c("v-divider", { staticClass: "w-100" }),
          _c("v-card-text", { staticClass: "pt-5" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("pages.settings.users.deleteDialog.subtitle")) +
                " "
            ),
          ]),
          _c("v-divider", { staticClass: "w-100" }),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.loading },
                  on: { click: _vm.close },
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "error", elevation: 0 },
                  on: { click: _vm.save },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "pages.settings.users.deleteDialog.confirmButton"
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }